import Vue from "vue";
import Vuex from "vuex";
import AuthService from "../services/auth.service";
import UserService from "../services/user.service";
import WappService from "../services/wapp.service";
import ContatoService from "../services/contato.service";
import DashService from "../services/dash.service";
Vue.use(Vuex);

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };
export default new Vuex.Store({
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                (user) => {
                    commit("loginSuccess", user);
                    return Promise.resolve(user);
                },
                (error) => {
                    commit("loginFailure");
                    return Promise.reject(error);
                }
            );
        },
        //tem que voltar os parametros pra registrar o usuario
        registrarUsuario({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return AuthService.register(
                payload.nome,
                payload.genero,
                payload.foto,
                payload.pis,
                payload.dataEntrada,
                payload.jornadaSemanal,
                payload.setores,
                payload.email,
                payload.senha
            ).then(
                (response) => {
                    commit("registradoSucess", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        enviarMsg({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.enviarMsg(payload.chatId, payload.body).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        concluirAtendimento({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.concluirAtendimento(
                payload.chatId,
                payload.col
            ).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        mudarSetor({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.mudarSetor(
                payload.chatId,
                payload.setor,
                payload.senderName
            ).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        colAtendeu({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.colAtendeu(payload.chatId, payload.col).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        modificarSeen({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.modificarSeen(payload.chatId, payload.seen).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        iniciarNovaConversa({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.iniciarNovaConversa(
                payload.telefone,
                payload.setor,
                payload.body
            ).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        enviarArquivos({ commit }, payload) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.enviarArquivos(
                payload.chatId,
                payload.arquivos,
                payload.caption
            ).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit("logout");
        },
        infoUsuario({ commit }) {
            return UserService.getInfoUsuario().then(
                (response) => {
                    var userDB = response.data;
                    commit("infoUsuario", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        editUsuario({ commit }, payload) {
            return UserService.editUsuario(payload).then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        removerUsuario({ commit }, payload) {
            return UserService.removerUsuario(payload).then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        listarUsuario({ commit }) {
            return UserService.listarUsuario().then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        wappItems({ commit }, setores) {
            return WappService.mensagemSetores(setores).then(
                (response) => {
                    var re = response.data;
                    commit("wappItems");
                    return Promise.resolve(re);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        wappListaHistorico({ commit }) {
            //alert(JSON.stringify(payload,null,'\t'))
            return WappService.listaHistorico().then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        mensagemHistorico({ commit }, chatId) {
            return WappService.mensagemHistorico(chatId).then(
                (response) => {
                    commit("genCommit", response.data);
                    return Promise.resolve(response.data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        chatsEmAberto({ commit }) {
            return WappService.chatsEmAberto().then(
                (response) => {
                    var re = response.data;
                    commit("wappItems");
                    return Promise.resolve(re);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        stats({ commit }) {
            return DashService.stats().then(
                (response) => {
                    var re = response.data;
                    commit("genCommit", re);
                    return Promise.resolve(re);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        msg({ commit }) {
            return DashService.msg().then(
                (response) => {
                    var re = response.data;
                    commit("genCommit", re);
                    return Promise.resolve(re);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        addContato({ commit }, payload) {
            return ContatoService.addContato(
                payload.nome,
                payload.telefone,
                payload.celular,
                payload.email,
                payload.complementares
            ).then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        editarContato({ commit }, payload) {
            return ContatoService.editarContato(
                payload.id,
                payload.nome,
                payload.telefone,
                payload.celular,
                payload.email,
                payload.complementares
            ).then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        removerContato({ commit }, payload) {
            return ContatoService.removerContato(payload.id).then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        listarContato({ commit }) {
            return ContatoService.listarContato().then(
                (response) => {
                    var userDB = response.data;
                    commit("genCommit", userDB);
                    return Promise.resolve(userDB);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        infoUsuario(state, userDB) {
            state.status.loggedIn = true;
            state.userDB = userDB;
        },
        wappItems(state) {
            state.status.loggedIn = true;
        },
        genCommit(state) {
            state.status.loggedIn = true;
        },
        loginSuccess(state) {
            state.status.loggedIn = true;
            state.user = user;
        },
        registradoSucess(state) {
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
    },
    /* modules: {
    auth: auth
  }*/
});
